// Converts poster tile prices (entered in AUD) into the visitor's active
// Shopify Markets currency, using Shopify's native Shopify.currency.rate.
// Falls back silently to the server-rendered AUD figure if multi-currency
// isn't active or the rate isn't available.
document.addEventListener('DOMContentLoaded', function () {
  if (!window.Shopify || !window.Shopify.currency) return;

  var rate = parseFloat(window.Shopify.currency.rate);
  var activeCurrency = window.Shopify.currency.active;

  if (!rate || isNaN(rate) || !activeCurrency) return;

  var elements = document.querySelectorAll('.collection-poster-tile__auto-price');
  if (!elements.length) return;

  var formatter;
  try {
    formatter = new Intl.NumberFormat(navigator.language || 'en', {
      style: 'currency',
      currency: activeCurrency,
      currencyDisplay: 'symbol',
    });
  } catch (e) {
    return;
  }

  elements.forEach(function (el) {
    var baseAmount = parseFloat(el.getAttribute('data-aud-amount'));
    if (isNaN(baseAmount)) return;

    el.textContent = formatter.format(baseAmount * rate);
  });
});